import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { loadFullVendor } from 'js/actions';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';

export default function useVendorsAdapter() {
  const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();

  const requestFullVendor = useCallback((connector: string) => {
    return dispatch(loadFullVendor(connector));
  }, []);

  return { requestFullVendor };
}
